import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthentificationComponent } from './components/auth/auth.component';
import { PdfComponent } from './components/common/pdf/pdf.component';
import { CartComponent } from './components/pages/cart/cart.component';
import { CategoriesComponent } from './components/pages/categories/categories.component';
import { CoursesStyleTwoComponent } from './components/pages/courses-style-two/courses-style-two.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { LoginComponent } from './components/pages/login/login.component';
import { MonitoringComponent } from './components/pages/monitoring/monitoring.component';
import { ProfileAuthenticationComponent } from './components/pages/profile-authentication/profile-authentication.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { ResetPasswordComponent } from './components/pages/reset-password/reset-password.component';
import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { TermsOfServiceComponent } from './components/pages/terms-of-service/terms-of-service.component';
import { HomeComponent } from './components/pages/vendor-certification-etraining/home.component';
import { AuthGuardService } from './services/guard/authCanload';
import { LoginGuardService } from './services/guard/loginguard';

const routes: Routes = [

    { path: '', component: HomeComponent,canActivate:[LoginGuardService ] },
    { path: 'pdf', component: PdfComponent },
    {
        path: 'inscription-registration',
        redirectTo: 'registration',
        pathMatch: 'full'
    },

    {path: 'signUp', component: SignUpComponent,canActivate:[LoginGuardService ]},
    {path: 'registration', component: ProfileAuthenticationComponent,canActivate:[LoginGuardService ]},
    {path: 'login', component: LoginComponent,canActivate:[LoginGuardService ]},
    {path: 'terms-of-service', component: TermsOfServiceComponent},

    {path: 'modules', component: CoursesStyleTwoComponent,
      canActivate:[AuthGuardService]},
    {path: 'my-account', loadChildren:() => import('./components/pages/profile/profile.module').then(mod => mod.ProfileModule), canActivate:[AuthGuardService]},
 
    {path: 'studies', component: CategoriesComponent,
     canActivate:[AuthGuardService]},
    {path: 'detail-module', component: CartComponent,
    canActivate:[AuthGuardService]},
    {path: 'class-homework', loadChildren:() => import('./components/pages/copy-checks/copy-check.module').then(mod => mod.CopyChecksModuleModule), canActivate:[AuthGuardService]},
    {path: 'zoom', loadChildren:() => import('./components/pages/zoom/zoom.module').then(mod => mod.ZoomCustomModule)},
    {path: 'program-followup', component: MonitoringComponent},
    {path: 'reset-password', component: ResetPasswordComponent},
    {path: 'auth', component: AuthentificationComponent},
    {path: 'students-registration', loadChildren:() => import('./components/pages/users-registration/users-registration.module').then(mod => mod.UsersRegistrationModule), canActivate:[AuthGuardService]},
    {path: 'students-registered', loadChildren:() => import('./components/pages/users/users.module').then(mod => mod.UsersModule), canActivate:[AuthGuardService]},
    {path: 'add-class-homework', loadChildren:() => import('./components/pages/class-work/class-work.module').then(mod => mod.ClassClassWorkModule), canActivate:[AuthGuardService]},
    {path: 'student', loadChildren:() => import('./components/pages/student/student.module').then(mod => mod.StudentModule), canActivate:[AuthGuardService]},
    {path: '**', component: ErrorComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }